"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContent = exports.StyledWhyPhishToolIntro = exports.StyledWhyPhishToolContent = exports.StyledWhyPhishToolImage = exports.StyledWhyPhishToolImageWrapper = void 0;
const ui_1 = require("@phishtool/ui");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledWhyPhishToolImageWrapper = styled_components_1.default.div.withConfig({ displayName: "StyledWhyPhishToolImageWrapper", componentId: "sc-1ctxys8" }) `
  position: relative;

  ${(0, ui_1.mq)({
    width: ['100%', '45%', '50%'],
})}

  &::after {
    box-shadow: 18px 18px 36px 36px inset rgba(255, 255, 255, 0.6);
    content: '';
    display: block;
    height: 100%;
    position: absolute;
    top: 0;
    width: 100%;
  }
`;
exports.StyledWhyPhishToolImage = styled_components_1.default.img.withConfig({ displayName: "StyledWhyPhishToolImage", componentId: "sc-il6goy" }) `
  display: block;
  width: 100%;
`;
exports.StyledWhyPhishToolContent = styled_components_1.default.div.withConfig({ displayName: "StyledWhyPhishToolContent", componentId: "sc-1xswf88" }) `
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${(0, ui_1.mq)({
    width: ['100%', '55%', '40%'],
})}
`;
exports.StyledWhyPhishToolIntro = styled_components_1.default.p.withConfig({ displayName: "StyledWhyPhishToolIntro", componentId: "sc-1makvh8" }) `
  ${(props) => props.theme.responsiveTypography.body.large};
  font-weight: ${(props) => props.theme.fontWeights.medium};
  margin: 0 0 ${(props) => props.theme.spacers.x3};
`;
exports.StyledContent = (0, styled_components_1.default)(ui_1.Paragraph).withConfig({ displayName: "StyledContent", componentId: "sc-1covfuv" }) `
  white-space: pre-wrap;
`;
